import { render, staticRenderFns } from "./ysSh.vue?vue&type=template&id=636be0e3&scoped=true"
import script from "./ysSh.vue?vue&type=script&lang=js"
export * from "./ysSh.vue?vue&type=script&lang=js"
import style0 from "./ysSh.vue?vue&type=style&index=0&id=636be0e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636be0e3",
  null
  
)

export default component.exports